<template>
  <div class="lwgl" v-on:scroll="handleScroll" >
    <div class="menu">
      <div style="display: flex; justify-content: space-around; background-color: #d2dae3">
        <a href="#first">一、Python 中的变量和对象</a>
        <a href="#second">二、可变对象和不可变对象</a>
        <a href="#third">三、参数传递机制</a>
        <a href="#four">四、函数参数传递机制的实际应用</a>
        <a href="#five">五、匿名函数 lambda</a>
        <a href="#six">六、函数式编程工具</a>
        <a href="#seven">七、高阶函数</a>
        <a href="#eight">八、总结</a>
      </div>
    </div>
    <div style="text-align: left; line-height: 25px; margin-top: 20px">
      <p>在 Python 中，对于函数的参数传递，有两种主要的方式：传值和传引用。事实上，Python 的参数传递是一种“传对象引用”的方式。接下来的文章我们将详细介绍 Python 的函数参数传递机制，这对理解 Python
        编程语言的底层实现以及优化你的代码都非常有帮助。
      </p>
    </div>
    <div style="text-align: left; line-height: 20px;">
      <p style="font-weight: bold" id="first">一、Python 中的变量和对象</p>
      <p>在深入理解参数传递之前，我们首先需要理解 Python 中的变量和对象的概念。</p>
      <p>在 Python 中，所有的数据都是对象，无论是数字、字符串还是自定义类型。而变量则是指向对象的引用。</p>
      <div style="display: flex; justify-content: space-between">
        <div style="background-color: #2B2B2B; color: white; width: 50%; border-radius: 15px; padding: 10px">
          <div style="border: 1px solid #585858">
            <div style="display: flex; flex-direction: row; " v-for="item in zcdCode" :key="item.id">
              <div style="width: 30px; background-color: #585858">
                <span v-if="item.fk" style="font-weight: bolder; color: blue">
                  ==>
                </span>
                <span v-if="item.nk" style="font-weight: bolder; color: red; ">
                  ==>
                </span>
              </div>
              <div style="width: 20px; background-color: #585858; height: 20px">
                {{item.id === "" ? '' : item.id}}
              </div>
              <div :style="{textIndent: item.ml + 'em'}" style="margin-left: 10px">
                {{item.con}}
              </div>
            </div>
          </div>

          <div style="width: 500px; display: flex; justify-content:center; margin-top: 10px; line-height: 10px">
            <div style="display: flex; justify-content: space-between; align-items: center">

              <span style="padding: 10px; color: white">第
              <span style="color: blue; font-weight: bolder">
                {{step}}
              </span>步</span>
              <el-button size="mini" @click="nextStep" v-if="step >= 0 && step < 4">下一步<i
                class="el-icon-arrow-right el-icon--right"></i></el-button>
              <el-button icon="el-icon-caret-right" type="success" size="mini" @click="startStep">重新运行
              </el-button>
            </div>
          </div>
          <div>Console</div>
          <div style="border: 1px solid #585858; color: white; padding: 5px">
            <div v-if="step > 2">94832830448320</div>
            <div v-if="step > 3">94832830448320</div>
          </div>
        </div>
        <div style="width: calc(50% - 20px); border-radius: 15px; background-color: #2B2B2B">
          <!-- 堆 栈 表示区域 -->
          <div style="width: 100%; height: max-content;  border-radius: 15px">
            <div style="width: 100%; height: max-content; border-radius: 15px">
              <div style="border: solid 1px #585858; border-radius: 15px; text-align: center; color: white">
            Python虚拟机全局数据区
          </div>
              <div
                style="display: flex; justify-content: space-around; height: max-content; padding: 10px; margin-top: 10px; font-size: 15px">
                <div style="width: 45%; border: solid 1px #585858; line-height: 30px; padding-bottom: 10px">
                  <div style="font-weight: bolder; text-align: center; color: white">栈</div>
                  <div style="display: flex; justify-content: center">
                    <div style="background-color: #d3dce6">
                      <div style="width: 200px; height: 50px; border: 1px solid #4c88ff" id="target3">

                      </div>
                      <div style="width: 200px; height: 50px; border: 1px solid #4c88ff" id="target4">

                      </div>
                      <div
                        style="width: 200px; height: 50px; border: 1px solid #4c88ff; line-height: 50px; text-align: center"
                        id="target1" >
                        <span v-if="step > 1">变量 y -> (94832830448320)</span>
                      </div>
                      <div
                        style="width: 200px; height: 50px; border: 1px solid #4c88ff; line-height: 50px; text-align: center"
                        id="target2" >
                        <span v-if="step >= 1">变量 x -> (94832830448320)</span>
                      </div>

                    </div>
                  </div>
                </div>
                <div style="width: 45%; border: solid 1px #585858; line-height: 30px">
                  <div style="font-weight: bolder; text-align: center; color: white">堆</div>
                  <div style="display: flex; justify-content: center">
                    <div style="width: 180px; height: 100px;  margin-left: 5px; color: white;" v-if="step >= 1" id="targetAim">
                      <div>分配内存空间</div>
                      <div style="background-color: #dd6161; line-height: 50px; text-align: center">
                        3 </br>(地址：94832830448320)
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p>在这个例子中，x 和 y 都是指向整数 3 这个对象的引用。我们可以通过 id() 函数查看它们指向的对象的内存地址，验证这一点。</p>
    </div>

    <div style="text-align: left; line-height: 25px">
      <p style="font-weight: bold" id="second">
        二、可变对象和不可变对象
      </p>
      <p>在 Python 中，对象可以分为可变对象和不可变对象。例如，列表、字典和集合是可变对象，而数字、字符串和元组是不可变对象。</p>
      <p>
        对于不可变对象，我们无法改变对象自身，但是可以改变变量所指向的对象。
      </p>
      <div style="display: flex; justify-content: space-between">
        <div style="background-color: #2B2B2B; color: white; width: 50%; border-radius: 15px; padding: 10px">
          <div style="border: 1px solid #585858; ">
            <div style="display: flex; flex-direction: row; " v-for="item in zcdCode1" :key="item.id">
              <div style="width: 30px; background-color: #585858">
                <span v-if="item.fk" style="font-weight: bolder; color: blue">
                  ==>
                </span>
                <span v-if="item.nk" style="font-weight: bolder; color: red; ">
                  ==>
                </span>
              </div>
              <div style="width: 20px; background-color: #585858; height: max-content">
                {{item.id === "" ? '' : item.id}}
              </div>
              <div :style="{textIndent: item.ml + 'em'}" style="margin-left: 10px">
                {{item.con}}
              </div>
            </div>
          </div>

          <div style="width: 500px; display: flex; justify-content:center; margin-top: 10px; line-height: 10px">
            <div style="display: flex; justify-content: space-between; align-items: center">

              <span style="padding: 10px; color: white">第
              <span style="color: blue; font-weight: bolder">
                {{step1}}
              </span>步</span>
              <el-button size="mini" @click="nextStep1" v-if="step1 >= 0 && step1 < 4">下一步<i
                class="el-icon-arrow-right el-icon--right"></i></el-button>
              <el-button icon="el-icon-caret-right" type="success" size="mini" @click="startStep1">重新运行
              </el-button>
            </div>
          </div>
          <div>Console</div>
          <div style="border: 1px solid #585858; color: white; padding: 5px">
            <div v-if="step1 > 1">94832830448320</div>
            <div v-if="step1 > 3">94832830448352</div>
          </div>
        </div>
        <div style="width: calc(50% - 20px); border-radius: 15px; background-color: #2B2B2B">
          <!-- 堆 栈 表示区域 -->
          <div style="width: 100%; height: max-content;  border-radius: 15px">
            <div style="width: 100%; height: max-content; border-radius: 15px">
              <div style="border: solid 1px #585858; border-radius: 15px; text-align: center; color: white">
            Python虚拟机全局数据区
          </div>
              <div
                style="display: flex; justify-content: space-around; height: max-content; padding: 10px; margin-top: 10px; font-size: 15px">
                <div style="width: 45%; border: solid 1px #585858; line-height: 30px; padding-bottom: 10px">
                  <div style="font-weight: bolder; text-align: center">栈</div>
                  <div style="display: flex; justify-content: center">
                    <div style="background-color: #d3dce6">
                      <div style="width: 200px; height: 50px; border: 1px solid #4c88ff" id="target7">

                      </div>
                      <div style="width: 200px; height: 50px; border: 1px solid #4c88ff" id="target8">

                      </div>
                      <div
                        style="width: 200px; height: 50px; border: 1px solid #4c88ff; line-height: 50px; text-align: center"
                        id="target5" >
                        <span v-if="step1 > 1"></span>
                      </div>
                      <div
                        style="width: 200px; height: 50px; border: 1px solid #4c88ff; line-height: 50px; text-align: center"
                        id="target6" >
                        <span v-if="step1 >= 1">变量 x -> (94832830448352)</span>
                      </div>

                    </div>
                  </div>
                </div>
                <div style="width: 45%; border: solid 1px #585858; line-height: 30px">
                  <div style="font-weight: bolder; text-align: center">堆</div>
                  <div style="display: flex; justify-content: center">
                    <div style="width: 180px; height: 100px;  margin-left: 5px; color: white;" v-if="step1 >= 1" id="targetAim1">
                      <div style="background-color: #dd6161; line-height: 50px; text-align: center">
                        3 </br>(地址：94832830448320)
                      </div>
                    </div>
                  </div>
                  <div style="display: flex; justify-content: center; margin-top: 2px">
                    <div style="width: 180px; height: 100px;  margin-left: 5px; color: white;" v-if="step1 > 2" id="targetAim11">
                      <div style="background-color: #dd6161; line-height: 50px; text-align: center">
                        4 </br>(地址：94832830448352)
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      对于可变对象，我们既可以改变对象自身，也可以改变变量所指向的对象
      <div style="display: flex; justify-content: space-between">
        <div style="background-color: #2B2B2B; color: white; width: 50%; border-radius: 15px; padding: 10px">
          <div style="border: 1px solid #585858; ">
            <div style="display: flex; flex-direction: row; " v-for="item in zcdCode2" :key="item.id">
              <div style="width: 30px; background-color: #585858">
                <span v-if="item.fk" style="font-weight: bolder; color: blue">
                  ==>
                </span>
                <span v-if="item.nk" style="font-weight: bolder; color: red; ">
                  ==>
                </span>
              </div>
              <div style="width: 20px; background-color: #585858; height: max-content">
                {{item.id === "" ? '' : item.id}}
              </div>
              <div :style="{textIndent: item.ml + 'em'}" style="margin-left: 10px">
                {{item.con}}
              </div>
            </div>
          </div>

          <div style="width: 500px; display: flex; justify-content:center; margin-top: 10px; line-height: 10px">
            <div style="display: flex; justify-content: space-between; align-items: center">

              <span style="padding: 10px; color: white">第
              <span style="color: blue; font-weight: bolder">
                {{step2}}
              </span>步</span>
              <el-button size="mini" @click="nextStep2" v-if="step2 >= 0 && step2 < 4">下一步<i
                class="el-icon-arrow-right el-icon--right"></i></el-button>
              <el-button icon="el-icon-caret-right" type="success" size="mini" @click="startStep2">重新运行
              </el-button>
            </div>
          </div>
          <div>Console</div>
          <div style="border: 1px solid #585858; color: white; padding: 5px">
            <div v-if="step2 > 1">94832830448320</div>
            <div v-if="step2 > 3">94832830448320</div>
          </div>
        </div>
        <div style="width: calc(50% - 20px); border-radius: 15px; background-color: #2B2B2B">
          <!-- 堆 栈 表示区域 -->
          <div style="width: 100%; height: max-content;  border-radius: 15px">
            <div style="width: 100%; height: max-content; border-radius: 15px">
              <div style="border: solid 1px #585858; border-radius: 15px; text-align: center; color: white">
            Python虚拟机全局数据区
          </div>
              <div
                style="display: flex; justify-content: space-around; height: max-content; padding: 10px; margin-top: 10px; font-size: 15px">
                <div style="width: 45%; border: solid 1px #585858; line-height: 30px; padding-bottom: 10px">
                  <div style="font-weight: bolder; text-align: center">栈</div>
                  <div style="display: flex; justify-content: center">
                    <div style="background-color: #d3dce6">
                      <div style="width: 200px; height: 50px; border: 1px solid #4c88ff" id="target9">

                      </div>
                      <div style="width: 200px; height: 50px; border: 1px solid #4c88ff" id="target10">

                      </div>
                      <div
                        style="width: 200px; height: 50px; border: 1px solid #4c88ff; line-height: 50px; text-align: center"
                        id="target11" >
                        <span v-if="step2 > 1"></span>
                      </div>
                      <div
                        style="width: 200px; height: 50px; border: 1px solid #4c88ff; line-height: 50px; text-align: center"
                        id="target12" >
                        <span v-if="step2 >= 1">变量 x -> (94832830448352)</span>
                      </div>

                    </div>
                  </div>
                </div>
                <div style="width: 45%; border: solid 1px #585858; line-height: 30px">
                  <div style="font-weight: bolder; text-align: center">堆</div>
                  <div style="display: flex; justify-content: center">
                    <div style="width: max-content; height: 100px;  margin-left: 5px; color: white;" v-if="step2 >= 1" id="targetAim2">
                      <div style=" line-height: 50px; text-align: center">
                          <div style="display: flex; flex-direction: row ">
                              <div style="border: 1px solid #f5dab1; width: 50px; height: 50px">1</div>
                              <div style="border: 1px solid #f5dab1; width: 50px; height: 50px">2</div>
                              <div style="border: 1px solid #f5dab1;  width: 50px; height: 50px">3</div>
                              <div style="border: 1px solid #f5dab1;  width: 50px; height: 50px" v-if="step2 > 2">4</div>
                              <span>(94832830448320)</span>
                          </div>

                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p>在这个例子中，我们先是让变量 x 指向了整数 3，然后又让 x 指向了整数 4。我们无法改变整数 3 自身，但是可以改变 x 所指向的对象。
        对于可变对象，我们既可以改变对象自身，也可以改变变量所指向的对象。</p>
    </div>

    <div style="text-align: left; line-height: 25px">
      <p style="font-weight: bold" id="third">
        三、参数传递机制
      </p>
      <p>在 Python 中，函数参数的传递遵循“传对象引用”的方式。对于可变对象和不可变对象，表现出来的效果类似传值和传引用。</p>
      <p>1. 不可变对象的参数传递</p>
      <p> 当我们将一个不可变对象作为参数传递给函数时，函数内部无法改变这个对象自身。函数如果对这个参数进行改变，实际上是创建了一个新的对象。</p>
      <div style="display: flex; justify-content: space-between">
        <div style="background-color: #2B2B2B; color: white; width: 50%; border-radius: 15px; padding: 10px">
          <div style="border: 1px solid #585858; ">
            <div style="display: flex; flex-direction: row; " v-for="item in zcdCode3" :key="item.id">
              <div style="width: 30px; background-color: #585858">
                <span v-if="item.fk" style="font-weight: bolder; color: blue">
                  ==>
                </span>
                <span v-if="item.nk" style="font-weight: bolder; color: red; ">
                  ==>
                </span>
              </div>
              <div style="width: 20px; background-color: #585858; height: max-content">
                {{item.id === "" ? '' : item.id}}
              </div>
              <div :style="{textIndent: item.ml + 'em'}" style="margin-left: 10px">
                {{item.con}}
              </div>
            </div>
          </div>

          <div style="width: 500px; display: flex; justify-content:center; margin-top: 10px; line-height: 10px">
            <div style="display: flex; justify-content: space-between; align-items: center">

              <span style="padding: 10px; color: white">第
              <span style="color: blue; font-weight: bolder">
                {{step3}}
              </span>步</span>
              <el-button size="mini" @click="nextStep3" v-if="step3 >= 0 && step3 < 6">下一步<i
                class="el-icon-arrow-right el-icon--right"></i></el-button>
              <el-button icon="el-icon-caret-right" type="success" size="mini" @click="startStep3">重新运行
              </el-button>
            </div>
          </div>
          <div>Console</div>
          <div style="border: 1px solid #585858; color: white; padding: 5px">
            <div v-if="step3 > 1">55665245</div>
            <div v-if="step3 > 2">55665245</div>
            <div v-if="step3 > 4">94832830</div>
            <div v-if="step3 > 6">3</div>
          </div>
        </div>
        <div style="width: calc(50% - 20px); border-radius: 15px; background-color: #2B2B2B">
          <!-- 堆 栈 表示区域 -->
          <div style="width: 100%; height: max-content;  border-radius: 15px">
            <div style="width: 100%; height: max-content; border-radius: 15px">
              <div style="border: solid 1px #585858; border-radius: 15px; text-align: center; color: white">
            Python虚拟机全局数据区
          </div>
              <div
                style="display: flex; justify-content: space-around; height: max-content; padding: 10px; margin-top: 10px; font-size: 15px">
                <div style="width: 45%; border: solid 1px #585858; line-height: 30px; padding-bottom: 10px">
                  <div style="font-weight: bolder; text-align: center">栈</div>
                  <div style="display: flex; justify-content: center">
                    <div style="background-color: #d3dce6">
                      <div style="width: 200px; height: 50px; border: 1px solid #4c88ff" >

                      </div>
                      <div style="width: 200px; height: 50px; border: 1px solid #4c88ff">

                      </div>
                      <div
                        style="width: 200px; height: 50px; border: 1px solid #4c88ff; line-height: 50px; text-align: center"
                        id="target311" >
                        <span v-if="step3 > 3">n -> (94832830)</span>
                        <span v-if="step3 == 3">n -> (55665245)</span>
                      </div>
                      <div
                        style="width: 200px; height: 50px; border: 1px solid #4c88ff; line-height: 50px; text-align: center"
                        id="target312" >
                        <span v-if="step3 >= 1">x -> (55665245)</span>
                      </div>

                    </div>
                  </div>
                </div>
                <div style="width: 45%; border: solid 1px #585858; line-height: 30px">
                  <div style="font-weight: bolder; text-align: center">堆</div>
                  <div style="display: flex; justify-content: center">

                    <div>
                      <div style="display: flex; flex-direction: column">
                        <div style="width: max-content; height: 100px;  margin-left: 5px; color: white;" v-if="step3 >= 1" id="targetAim32">
                          <div style=" line-height: 50px; text-align: center">
                            <div style="display: flex; flex-direction: row ">
                              <div style="border: 1px solid #f5dab1; width: 50px; height: 50px">3</div>
                              <span>(55665245)</span>
                            </div>

                          </div>
                        </div>

                        <div style="width: max-content; height: 100px;  margin-left: 5px; color: white; margin-top: 20px" v-if="step3 >= 4" id="targetAim33">
                          <div style=" line-height: 50px; text-align: center">
                            <div style="display: flex; flex-direction: row ">
                              <div style="border: 1px solid #f5dab1; width: 50px; height: 50px">10</div>
                              <span>(94832830)</span>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>

                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p>在这个例子中，函数 change() 试图改变参数 n。但是因为 n 是一个不可变对象，所以函数内部其实创建了一个新的对象，而原来的对象并没有改变。</p>
    </div>

    <div style="text-align: left; line-height: 25px">

      <p>2. 可变对象的参数传递</p>
      <p>当我们将一个可变对象作为参数传递给函数时，函数内部可以改变这个对象自身。</p>
      <div style="display: flex; justify-content: space-between">
        <div style="background-color: #2B2B2B; color: white; width: 50%; border-radius: 15px; padding: 10px">
          <div style="border: 1px solid #585858; ">
            <div style="display: flex; flex-direction: row; " v-for="item in zcdCode4" :key="item.id">
              <div style="width: 30px; background-color: #585858">
                <span v-if="item.fk" style="font-weight: bolder; color: blue">
                  ==>
                </span>
                <span v-if="item.nk" style="font-weight: bolder; color: red; ">
                  ==>
                </span>
              </div>
              <div style="width: 20px; background-color: #585858; height: max-content">
                {{item.id === "" ? '' : item.id}}
              </div>
              <div :style="{textIndent: item.ml + 'em'}" style="margin-left: 10px">
                {{item.con}}
              </div>
            </div>
          </div>

          <div style="width: 500px; display: flex; justify-content:center; margin-top: 10px; line-height: 10px">
            <div style="display: flex; justify-content: space-between; align-items: center">

              <span style="padding: 10px; color: white">第
              <span style="color: blue; font-weight: bolder">
                {{step4}}
              </span>步</span>
              <el-button size="mini" @click="nextStep4" v-if="step4 >= 0 && step4 < 6">下一步<i
                class="el-icon-arrow-right el-icon--right"></i></el-button>
              <el-button icon="el-icon-caret-right" type="success" size="mini" @click="startStep4">重新运行
              </el-button>
            </div>
          </div>
          <div>Console</div>
          <div style="border: 1px solid #585858; color: white; padding: 5px">
            <div v-if="step4 > 1">55665245</div>
            <div v-if="step4 > 2">55665245</div>
            <div v-if="step4 > 4">55665245</div>
            <div v-if="step4 > 5">[1,2,3,4]</div>
          </div>
        </div>
        <div style="width: calc(50% - 20px); border-radius: 15px; background-color: #2B2B2B">
          <!-- 堆 栈 表示区域 -->
          <div style="width: 100%; height: max-content;  border-radius: 15px">
            <div style="width: 100%; height: max-content; border-radius: 15px">
              <div style="border: solid 1px #585858; border-radius: 15px; text-align: center; color: white">
            Python虚拟机全局数据区
          </div>
              <div
                style="display: flex; justify-content: space-around; height: max-content; padding: 10px; margin-top: 10px; font-size: 15px">
                <div style="width: 45%; border: solid 1px #585858; line-height: 30px; padding-bottom: 10px">
                  <div style="font-weight: bolder; text-align: center">栈</div>
                  <div style="display: flex; justify-content: center">
                    <div style="background-color: #d3dce6">
                      <div style="width: 200px; height: 50px; border: 1px solid #4c88ff" >

                      </div>
                      <div style="width: 200px; height: 50px; border: 1px solid #4c88ff">

                      </div>
                      <div
                        style="width: 200px; height: 50px; border: 1px solid #4c88ff; line-height: 50px; text-align: center"
                        id="target411" >
                        <span v-if="step4 > 2">n -> (55665245)</span>
                      </div>
                      <div
                        style="width: 200px; height: 50px; border: 1px solid #4c88ff; line-height: 50px; text-align: center"
                        id="target412" >
                        <span v-if="step4 >= 1">x -> (55665245)</span>
                      </div>

                    </div>
                  </div>
                </div>
                <div style="width: 45%; border: solid 1px #585858; line-height: 30px">
                  <div style="font-weight: bolder; text-align: center">堆</div>
                  <div style="display: flex; justify-content: center">
                    <div style="width: max-content; height: 100px;  margin-left: 5px; color: white;" v-if="step4 >= 1" id="targetAim42">
                      <div style=" line-height: 50px; text-align: center">
                        <div style="display: flex; flex-direction: row ">
                          <div style="border: 1px solid #f5dab1; width: 50px; height: 50px">1</div>
                          <div style="border: 1px solid #f5dab1; width: 50px; height: 50px">2</div>
                          <div style="border: 1px solid #f5dab1;  width: 50px; height: 50px">3</div>
                          <div style="border: 1px solid #f5dab1;  width: 50px; height: 50px" v-if="step4 > 3">4</div>
                          <span>(55665245)</span>
                        </div>

                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p>在这个例子中，函数 change() 改变了参数 n。因为 n 是一个可变对象，所以函数内部的改变影响到了原来的对象。</p>
    </div>


    <div style="text-align: left; line-height: 25px">

      <p style="font-weight: bold" id="four">四、函数参数传递机制的实际应用</p>
      <p>理解了 Python 的参数传递机制，有助于我们编写出更好的代码。例如，如果我们知道一个函数内部会改变传入的可变对象，我们可能需要在传入参数之前先创建一个副本。</p>
      <div style="display: flex; justify-content: space-between">
        <div style="background-color: #2B2B2B; color: white; width: 50%; border-radius: 15px; padding: 10px">
          <div style="border: 1px solid #585858; ">
            <div style="display: flex; flex-direction: row; " v-for="item in zcdCode5" :key="item.id">
              <div style="width: 30px; background-color: #585858">
                <span v-if="item.fk" style="font-weight: bolder; color: blue">
                  ==>
                </span>
                <span v-if="item.nk" style="font-weight: bolder; color: red; ">
                  ==>
                </span>
              </div>
              <div style="width: 20px; background-color: #585858; height: max-content">
                {{item.id === "" ? '' : item.id}}
              </div>
              <div :style="{textIndent: item.ml + 'em'}" style="margin-left: 10px">
                {{item.con}}
              </div>
            </div>
          </div>

          <div style="width: 500px; display: flex; justify-content:center; margin-top: 10px; line-height: 10px">
            <div style="display: flex; justify-content: space-between; align-items: center">

              <span style="padding: 10px; color: white">第
              <span style="color: blue; font-weight: bolder">
                {{step5}}
              </span>步</span>
              <el-button size="mini" @click="nextStep5" v-if="step5 >= 0 && step5 < 5">下一步<i
                class="el-icon-arrow-right el-icon--right"></i></el-button>
              <el-button icon="el-icon-caret-right" type="success" size="mini" @click="startStep5">重新运行
              </el-button>
            </div>
          </div>
          <div>Console</div>
          <div style="border: 1px solid #585858; color: white; padding: 5px">
            <div v-if="step5 > 1">30448320</div>
            <div v-if="step5 > 3">[1,2,3]</div>
          </div>
        </div>
        <div style="width: calc(50% - 20px); border-radius: 15px; background-color: #2B2B2B">
          <!-- 堆 栈 表示区域 -->
          <div style="width: 100%; height: max-content;  border-radius: 15px">
            <div style="width: 100%; height: max-content; border-radius: 15px">
              <div style="border: solid 1px #585858; border-radius: 15px; text-align: center; color: white">
            Python虚拟机全局数据区
          </div>
              <div
                style="display: flex; justify-content: space-around; height: max-content; padding: 10px; margin-top: 10px; font-size: 15px">
                <div style="width: 45%; border: solid 1px #585858; line-height: 30px; padding-bottom: 10px">
                  <div style="font-weight: bolder; text-align: center">栈</div>
                  <div style="display: flex; justify-content: center">
                    <div style="background-color: #d3dce6">
                      <div style="width: 200px; height: 50px; border: 1px solid #4c88ff" >

                      </div>
                      <div style="width: 200px; height: 50px; border: 1px solid #4c88ff" >

                      </div>
                      <div
                        style="width: 200px; height: 50px; border: 1px solid #4c88ff; line-height: 50px; text-align: center"
                        id="target511" >
                        <span v-if="step5 > 2">n -> (28304483)</span>
                      </div>
                      <div
                        style="width: 200px; height: 50px; border: 1px solid #4c88ff; line-height: 50px; text-align: center"
                        id="target512" >
                        <span v-if="step5 >= 1">x -> (30448320)</span>
                      </div>

                    </div>
                  </div>
                </div>
                <div style="width: 45%; border: solid 1px #585858; line-height: 30px">
                  <div style="font-weight: bolder; text-align: center">堆</div>
                  <div style="display: flex; flex-direction: column">
                    <div>
                      <div style="width: max-content; height: 100px;  margin-left: 5px; color: white;" v-if="step5 >= 1" id="targetAim52">
                        <div style=" line-height: 50px; text-align: center">
                          <div style="display: flex; flex-direction: row ">
                            <div style="border: 1px solid #f5dab1; width: 50px; height: 50px">1</div>
                            <div style="border: 1px solid #f5dab1; width: 50px; height: 50px">2</div>
                            <div style="border: 1px solid #f5dab1;  width: 50px; height: 50px">3</div>
                            <span>(30448320)</span>
                          </div>

                        </div>
                      </div>
                      <div style="width: max-content; height: 100px;  margin-left: 5px; color: white; margin-top: 20px" v-if="step5 > 2" id="targetAim53">
                        <div style=" line-height: 50px; text-align: center">
                          <div style="display: flex; flex-direction: row ">
                            <div style="border: 1px solid #f5dab1; width: 50px; height: 50px">1</div>
                            <div style="border: 1px solid #f5dab1; width: 50px; height: 50px">2</div>
                            <div style="border: 1px solid #f5dab1;  width: 50px; height: 50px">3</div>
                            <div style="border: 1px solid #f5dab1;  width: 50px; height: 50px" v-if="step5 > 3" >4</div>
                            <span>(28304483)</span>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p>在这个例子中，我们传入了 x 的副本，因此函数内部的改变不会影响到 x。</p>

      <p>总的来说，Python 的函数参数传递机制遵循“传对象引用”的方式，理解这一点，能帮助我们更好的理解 Python 的工作原理，并编写出更有效率和可读性更强的代码。</p>

      <p style="font-weight: bold" id="five">五、匿名函数 lambda</p>
      <p>lambda 函数在 Python 编程语言中使用频率非常高，使用起来非常灵活、巧妙；</p><p>那么，什么是lambda ？它有哪些用法和应用场景呢 ？</p><p> </p><p>1. lambda 语法</p><p>lambda是一种不需要名字（即标识符）、由一个单独表达式成的匿名内联函数，表达式会在调用时被求值。lambda 函数的语法只包含一个语句，表现形式如下：</p><p>lambda [arg1 [,arg2,.....argn]]:expression</p><p>也就是说lambda函数包含三个部分：</p><p>系统关键字lamdbda；</p><p>参数；</p><p>函数体</p><p>lambda函数可以包含任意多的参数，但是函数体部分只能包含一个表达式。</p><p> </p><p>此外，lambda函数用一行代码写成，并且被立即调用。</p><p> </p><p>2. lambda 特性</p><p>ü lambda 函数是匿名的：</p><p>所谓匿名函数，通俗地说就是没有名字的函数。lambda函数没有名字。</p><p>ü lambda 函数有输入和输出：</p><p>输入是传入到参数列表argument_list的值，输出是根据表达式expression计算得到的值。</p><p>ü lambda 函数拥有自己的命名空间：</p><p>不能访问自己参数列表之外或全局命名空间里的参数，只能完成非常简单的功能。</p><p>常见的lambda函数示例：</p>
      <div style="background-color: #2B2B2B; color: white; width: 50%; border-radius: 15px; padding: 10px">
        <div style="border: 1px solid #585858">
          <div style="display: flex; flex-direction: row; " v-for="item in zcdCode6" :key="item.id">
            <div style="width: 30px; background-color: #585858">
                <span v-if="item.fk" style="font-weight: bolder; color: blue">
                  ==>
                </span>
              <span v-if="item.nk" style="font-weight: bolder; color: red; ">
                  ==>
                </span>
            </div>
            <div style="width: 20px; background-color: #585858; height: max-content">
              {{item.id === "" ? '' : item.id}}
            </div>
            <div style="display: flex; justify-content: space-between; margin-left: 10px" >
              <div :style="{textIndent: item.ml + 'em'}" >
                {{item.con}}
              </div>
              <div style="color: #8c939d" v-if="item.fk">
                {{item.a}}
              </div>
            </div>

          </div>
        </div>

        <div style="width: 500px; display: flex; justify-content:center; margin-top: 10px; line-height: 10px">
          <div style="display: flex; justify-content: space-between; align-items: center">

              <span style="padding: 10px; color: white">第
              <span style="color: blue; font-weight: bolder">
                {{step6}}
              </span>步</span>
            <el-button size="mini" @click="nextStep6" v-if="step6 >= 0 && step6 < 4">下一步<i
              class="el-icon-arrow-right el-icon--right"></i></el-button>
            <el-button icon="el-icon-caret-right" type="success" size="mini" @click="startStep61">重新运行
            </el-button>
          </div>
        </div>

      </div>
      <p><br></p><p>1. lambda 常见用法</p><p>由于lambda语法是固定的，其本质上只有一种用法，那就是定义一个lambda函数。</p><p>在实际中，根据这个lambda函数应用场景的不同，可以将lambda函数的用法扩展为以下几种：</p><p>① 将lambda函数赋值给一个变量，通过这个变量间接调用该lambda函数。</p>
      <div style="background-color: #2B2B2B; color: white; width: 50%; border-radius: 15px; padding: 10px">
        <div style="border: 1px solid #585858; padding: 5px">
          <span>add = lambda x, y: x+y</span>
          <span style="color: #8c939d">#相当于定义了加法函数lambda x, y: x+y，并将其赋值给变量add，这样变量add就指向了具有加法功能的函数。</span>
        </div>
      </div>
      <p>具有加法功能的函数。</p>
      <p>这时我们如果执行add(1, 2)，其输出结果就为 3。</p>

      <p>② 将lambda函数赋值给其他函数，从而将其他函数用该lambda函数替换。</p>
      <div style="background-color: #2B2B2B; color: white; width: 50%; border-radius: 15px; padding: 10px">
        <div style="border: 1px solid #585858; padding: 5px">
          <div style="color: #8c939d"># 为了把标准库time中的函数sleep的功能屏蔽(Mock)，我们可以在程序初始化时调用</div>
          <div>time.sleep=lambda x: None</div>
          <div style="color: #8c939d"># 这样，在后续代码中调用time库的sleep函数将不会执行原有的功能。</div>
          <div style="color: #8c939d"># 例如：</div>
          <div style="color: #8c939d"># 程序不会休眠 3 秒钟，而是因为lambda输出为None，所以这里结果是什么都不做</div>
          <div>time.sleep(3)	</div>
        </div>
      </div>
      <p>③ 将lambda函数作为参数传递给其他函数。</p><p>虽然 lambda 函数功能有限（只能写在一行上，不能包含复杂的逻辑），但在某些情况下，它的使用可以让代码更简洁。例如，当我们需要传入一个小的、临时的函数作为其他函数的参数时，就可以使用 lambda。</p>
      <div style="background-color: #2B2B2B; color: white; width: 50%; border-radius: 15px; padding: 10px">
        <div style="border: 1px solid #585858; padding: 5px">
          <div style="color: #8c939d"># 使用lambda在列表排序中实现自定义排序规则</div>
          <div>data = [{'name':'Alan', 'age':20}, {'name':'Lisa', 'age':18}, {'name':'Tom', 'age':22}]</div>
          <div >data.sort(key=lambda x: x['age'])</div>
          <div >print(data)</div>
          <div style="color: #8c939d"># 输出：[{'name': 'Lisa', 'age': 18}, {'name': 'Alan', 'age': 20}, {'name': 'Tom', 'age': 22}]
在这个例子中，我们使用 lambda 函数作为 sort() 函数的 key 参数，来实现根据年龄的排序。</div>
        </div>
      </div>


      <p style="font-weight: bold" id="six">六、函数式编程工具</p>
      <p>Python 提供了一些内建函数，用于支持函数式编程，如 map()、filter() 和 reduce() 等。这些函数可以用来对列表或其他可迭代对象进行操作，而无需编写循环。</p><p> </p><p>1. map() 函数</p><p> </p><p>ü 描述：</p><p>map() 函数接收一个函数和一个可迭代对象作为参数，并将该函数应用于可迭代对象的每个元素，然后返回一个新的可迭代对象。map() 会根据提供的函数对指定序列做映射。</p><p>第一个参数 function 以参数序列中的每一个元素调用 function 函数，返回包含每次 function 函数返回值的新列表。</p><p>ü 语法：</p><p>map(function, iterable, ...)</p><p>ü 参数：</p><p>function ----&gt; 函数</p><p>iterable ----&gt; 一个或多个序列</p><p>ü 返回值：</p><p>Python 2.x 版本返回的是列表</p><p>Python 3.x 版本返回的是迭代器</p>
      <div style="background-color: #2B2B2B; color: white; width: 50%; border-radius: 15px; padding: 10px">
        <div style="border: 1px solid #585858; padding: 5px">
          <div style="color: #8c939d"># ===========一般写法：===========</div>
          <div style="color: #8c939d"># 1、计算平方数</div>
          <div >def square(x):</div>
          <div style="text-indent: 2em">return x ** 2</div>
          <div >&nbsp;</div>
          <div ># 计算列表各个元素的平方</div>
          <div>map(square, [1,2,3,4,5])</div>
        </div>
        <div style="text-align: center; padding-top: 5px">
          <el-button icon="el-icon-caret-right" type="success" size="mini" @click="startStep6">运行猜结果
          </el-button>
        </div>
      </div>

      <div style="background-color: #2B2B2B; color: white; width: 50%; border-radius: 15px; padding: 10px; margin-top: 5px">
        <div style="border: 1px solid #585858; padding: 5px">
          <div style="color: #8c939d"># ===========匿名函数写法：============</div>
          <div style="color: #8c939d"># 2、计算平方数，lambda 写法</div>
          <div >map(lambda x: x ** 2, [1, 2, 3, 4, 5])</div>
        </div>
        <div style="text-align: center; padding-top: 5px">
          <el-button icon="el-icon-caret-right" type="success" size="mini" @click="startStep7">运行猜结果
          </el-button>
        </div>
      </div>

      <div style="background-color: #2B2B2B; color: white; width: 50%; border-radius: 15px; padding: 10px; margin-top: 5px">
        <div style="border: 1px solid #585858; padding: 5px">
          <div style="color: #8c939d"># 3、提供两个列表，将其相同索引位置的列表元素进行相加</div>
          <div >map(lambda x: x ** 2, [1, 2, 3, 4, 5])</div>
        </div>
        <div style="text-align: center; padding-top: 5px">
          <el-button icon="el-icon-caret-right" type="success" size="mini" @click="startStep8">运行猜结果
          </el-button>
        </div>
      </div>
      <p><br></p><p>2. reduce() 函数</p><p>ü 描述：</p><p>reduce() 函数会对参数序列中元素进行累积。</p><p>函数将一个数据集合（链表，元组等）中的所有数据进行下列操作：用传给 reduce 中的函数 function（有两个参数）先对集合中的第 1、2 个元素进行操作，得到的结果再与第三个数据用 function 函数运算，最后得到一个结果。</p><p>ü 语法：</p><p>reduce(function, iterable[, initializer])</p><p>ü 参数：</p><p>function &nbsp;----&gt; 函数，有两个参数</p><p>iterable &nbsp; ----&gt; 可迭代对象</p><p>initializer ----&gt; 可选，初始参数</p><p>ü 返回值：</p><p>返回函数计算结果。</p><p><br></p>
      <div style="background-color: #2B2B2B; color: white; width: 50%; border-radius: 15px; padding: 10px; margin-top: 5px">
        <div style="border: 1px solid #585858; padding: 5px">
          <div style="color: #8c939d"># ===========一般写法：===========</div>
          <div style="color: #8c939d"># 1、两数相加</div>
          <div >def add(x, y): </div>
          <div style="text-indent: 2em;">return x + y </div>
          <div style="text-indent: 2em;">&nbsp;</div>
          <div style="color: #8c939d"># 计算列表元素和：1+3+5+7+9</div>
          <div >reduce(add, [1, 3, 5, 7, 9])    </div>
        </div>
        <div style="text-align: center; padding-top: 5px">
          <el-button icon="el-icon-caret-right" type="success" size="mini" @click="startStep9">运行猜结果
          </el-button>
        </div>
      </div>
      <p><br></p><p>===========执行步骤解析：===========</p><p>调用 reduce(add, [1, 3, 5, 7, 9])时，reduce函数将做如下计算：</p><p>1 先计算头两个元素：f(1, 3)，结果为4；</p><p>2 再把结果和第3个元素计算：f(4, 5)，结果为9；</p><p>3 再把结果和第4个元素计算：f(9, 7)，结果为16；</p><p>4 再把结果和第5个元素计算：f(16, 9)，结果为25；</p><p>5 由于没有更多的元素了，计算结束，返回结果25。</p>
      <div style="background-color: #2B2B2B; color: white; width: 50%; border-radius: 15px; padding: 10px; margin-top: 5px">
        <div style="border: 1px solid #585858; padding: 5px">
          <div style="color: #8c939d"># ===========匿名函数写法：===========</div>
          <div style="color: #8c939d"># 2、两数相加，lambda 写法</div>
          <div>reduce(lambda x, y: x + y, [1, 2, 3, 4, 5]) </div>
        </div>
        <div style="text-align: center; padding-top: 5px">
          <el-button icon="el-icon-caret-right" type="success" size="mini" @click="startStep10">运行猜结果
          </el-button>
        </div>
      </div>
      <p>3. sorted() 函数</p><p>sorted() 函数对所有可迭代的对象进行排序操作。</p><p>ü sort 与 sorted 区别：</p><p>sort 是 list 的一个方法，而 sorted 可以对所有可迭代的对象进行排序操作。</p><p>list 的 sort 方法返回的是对已经存在的列表进行操作，无返回值，而内建函数 sorted 方法返回的是一个新的 list，而不是在原来的基础上进行的操作。</p><p>ü 语法：</p><p>sorted(iterable[, cmp[, key[, reverse]]])</p><p>ü 参数说明：</p><p>iterable &nbsp;----&gt; 可迭代对象。</p><p>cmp &nbsp; &nbsp; &nbsp; ----&gt; 比较的函数，这个具有两个参数，参数的值都是从可迭代对象中取出，此函数必须遵守的规则为，大于则返回1，小于则返回-1，等于则返回0。</p><p>key &nbsp; &nbsp; &nbsp; &nbsp;----&gt; 主要是用来进行比较的元素，只有一个参数，具体的函数的参数就是取自于可迭代对象中，指定可迭代对象中的一个元素来进行排序。</p><p>reverse &nbsp;----&gt; 排序规则，reverse = True 降序 ， reverse = False 升序（默认）。</p><p>ü 返回值：</p><p>返回重新排序的列表。</p>
      <div style="background-color: #2B2B2B; color: white; width: 50%; border-radius: 15px; padding: 10px; margin-top: 5px">
        <div style="border: 1px solid #585858; padding: 5px">
          <div style="color: #8c939d"># ===========一般用法：===========</div>
          <div style="color: #8c939d"># 1、简单排序</div>
          <div >a = [5,7,6,3,4,1,2]</div>
          <div style="color: #8c939d"># 使用sorted，保留原列表，不改变列表a的值</div>
          <div>b = sorted(a) </div>

        </div>
        <div style="text-align: center; padding-top: 5px">
          <el-button icon="el-icon-caret-right" type="success" size="mini" @click="startStep11">运行a结果
          </el-button>
          <el-button icon="el-icon-caret-right" type="success" size="mini" @click="startStep12">运行b结果
          </el-button>
        </div>
      </div>

      <div style="background-color: #2B2B2B; color: white; width: 50%; border-radius: 15px; padding: 10px; margin-top: 5px">
        <div style="border: 1px solid #585858; padding: 5px">
          <div style="color: #8c939d"># ===========匿名函数用法：===========</div>
          <div >L=[('b',2),('a',1),('c',3),('d',4)]</div>
          <div style="color: #8c939d"># 2、利用参数 cmp 排序</div>
          <div>sorted(L, cmp=lambda x,y:cmp(x[1],y[1]))</div>
          <div style="color: #8c939d"># 3、利用参数 key 排序</div>
          <div>sorted(L, key=lambda x:x[1])</div>
        </div>
        <div style="text-align: center; padding-top: 5px">
          <el-button icon="el-icon-caret-right" type="success" size="mini" @click="startStep13">运行cmp排序结果
          </el-button>
          <el-button icon="el-icon-caret-right" type="success" size="mini" @click="startStep14">运行参数key排序结果
          </el-button>
        </div>
      </div>

      <div style="background-color: #2B2B2B; color: white; width: 50%; border-radius: 15px; padding: 10px; margin-top: 5px">
        <div style="border: 1px solid #585858; padding: 5px">
          <div style="color: #8c939d"># 4、按年龄升序</div>
          <div >students = [('john', 'A', 15), ('jane', 'B', 12), ('dave', 'B', 10)]</div>
          <div>sorted(students, key=lambda s: s[2])</div>
          <div>sorted(L, cmp=lambda x,y:cmp(x[1],y[1]))</div>
          <div style="color: #8c939d"># 5、按年龄降序</div>
          <div>sorted(students, key=lambda s: s[2], reverse=True)</div>
        </div>
        <div style="text-align: center; padding-top: 5px">
          <el-button icon="el-icon-caret-right" type="success" size="mini" @click="startStep15">运行年龄升序结果
          </el-button>
          <el-button icon="el-icon-caret-right" type="success" size="mini" @click="startStep16">运行年龄降序结果
          </el-button>
        </div>
      </div>
      <p>4. filter() 函数</p><p>ü 描述：</p><p>filter() 函数用于过滤序列，过滤掉不符合条件的元素，返回由符合条件元素组成的新列表。</p><p> </p><p>该接收两个参数，第一个为函数，第二个为序列，序列的每个元素作为参数传递给函数进行判，然后返回 True 或 False，最后将返回 True 的元素放到新列表中。</p><p>ü 语法：</p><p>filter(function, iterable)</p><p>ü 参数：</p><p>function ----&gt; 判断函数。</p><p>iterable &nbsp;----&gt; 可迭代对象。</p><p>ü 返回值：</p><p>Pyhton2.7 返回列表，Python3.x 返回迭代器对象</p>
      <div style="background-color: #2B2B2B; color: white; width: 50%; border-radius: 15px; padding: 10px; margin-top: 5px">
        <div style="border: 1px solid #585858; padding: 5px">
          <div style="color: #8c939d"># ===========一般用法：===========</div>
          <div style="color: #8c939d"># 1、过滤出列表中的所有奇数</div>
          <div >def is_odd(n):</div>
          <div style="text-indent: 2em">return n % 2 == 1</div>
          <div>&nbsp;</div>
          <div>newlist = filter(is_odd, [1, 2, 3, 4, 5, 6, 7, 8, 9, 10])</div>
          <div>print(list(newlist))</div>
          <div>&nbsp;</div>
          <div style="color: #8c939d"># ===========匿名函数用法：===========</div>
          <div style="color: #8c939d"># 2、将列表[1, 2, 3]中能够被3整除的元素过滤出来</div>
          <div >newlist = filter(lambda x: x % 3 == 0, [1, 2, 3])</div>
          <div>print(list(newlist))</div>
        </div>
        <div style="text-align: center; padding-top: 5px">
          <el-button icon="el-icon-caret-right" type="success" size="mini" @click="startStep17">运行预期结果一
          </el-button>
          <el-button icon="el-icon-caret-right" type="success" size="mini" @click="startStep18">运行预期结果二
          </el-button>
        </div>
      </div>

      <p style="font-weight: bold" id="seven">七、高阶函数</p>
      <p>1. 什么是高阶函数？</p><p>在Python中，函数可以被当作变量一样进行操作，包括作为参数传递给其他函数，或者作为返回值从函数中返回。这种能够处理函数的函数就被称为高阶函数。简而言之，高阶函数就是能够接受函数作为参数或者返回函数的函数。</p><p>在 Python 中，函数是第一类对象，这意味着函数可以像其他数据类型一样进行操作，例如可以赋值给变量、作为参数传递、作为返回值返回等。这种特性使得Python中的函数可以非常灵活地被用于各种不同的场景。</p><p> </p><p>2. 高阶函数的用法</p><p>高阶函数在Python中有许多用法，包括但不限于以下几种：</p><p> </p><p>① 函数作为参数传递</p><p>高阶函数可以接受一个或多个函数作为参数传递给其他函数。这种用法常常用于将某种操作应用到一个序列（例如列表、元组等）的每个元素上，或者用于根据某些条件筛选出符合条件的元素。</p><p>例如，我们可以使用内置函数map()来将一个函数应用到一个序列的每个元素上，生成一个新的序列：</p>
      <div style="background-color: #2B2B2B; color: white; width: 50%; border-radius: 15px; padding: 10px; margin-top: 5px">
        <div style="border: 1px solid #585858; padding: 5px">
          <div>def square(x):</div>
          <div style="text-indent: 2em">return x * x</div>
          <div>&nbsp;</div>
          <div>squares = map(square, numbers)</div>
          <div>print(list(squares))</div>
        </div>
        <div style="text-align: center; padding-top: 5px">
          <el-button icon="el-icon-caret-right" type="success" size="mini" @click="startStep19">运行结果
          </el-button>
        </div>
      </div>
      <p>在上面的例子中，square()函数作为参数传递给map()函数，用于将numbers列表中的每个元素平方。</p><p> </p><p>②函数作为返回值返回</p><p>高阶函数可以在函数内部定义并返回另一个函数。这种用法常常用于创建闭包（closure），即一个带有捕获的外部变量的函数。</p><p>例如，我们可以定义一个函数make_adder()，用于生成一个可以实现加法的函数：</p>
      <div style="background-color: #2B2B2B; color: white; width: 50%; border-radius: 15px; padding: 10px; margin-top: 5px">
        <div style="border: 1px solid #585858; padding: 5px">
          <div>def make_adder(x):</div>
          <div style="text-indent: 2em">def add(y):</div>
          <div style="text-indent: 4em">return x + y</div>
          <div style="text-indent: 2em">return add</div>
          <div>&nbsp;</div>
          <div>add_5 = make_adder(5)</div>
          <div>print(add_5(3))</div>
        </div>
        <div style="text-align: center; padding-top: 5px">
          <el-button icon="el-icon-caret-right" type="success" size="mini" @click="startStep20">运行结果
          </el-button>
        </div>
      </div>
      <p>在上面的例子中，make_adder()函数接受一个参数x，并返回一个新的函数add()，这个新的函数可以在执行时捕获到x的值，并与传入的参数y进行相加。</p><p> </p><p>③ 函数可以嵌套定义</p><p>在Python中，函数可以在其他函数内部定义，这样的函数称为嵌套函数（nested function）。嵌套函数可以访问包含它的外层函数的变量，这种特性在高阶函数中经常被用到。</p><p>例如，我们可以定义一个函数calculate()，它接受一个操作符作为参数，并返回一个执行相应操作的函数：</p>
      <div style="background-color: #2B2B2B; color: white; width: 50%; border-radius: 15px; padding: 10px; margin-top: 5px">
        <div style="border: 1px solid #585858; padding: 5px">
          <div>def calculate(operator):</div>
          <div style="text-indent: 2em">def add(x, y):</div>
          <div style="text-indent: 4em">return x + y</div>
          <div style="text-indent: 2em">def subtract(x, y):</div>
          <div style="text-indent: 4em">return x - y</div>
          <div style="text-indent: 2em">def multiply(x, y):</div>
          <div style="text-indent: 4em">return x + y</div>
          <div style="text-indent: 2em">def divide(x, y):</div>
          <div style="text-indent: 4em">return x / y</div>
          <div style="text-indent: 4em">&nbsp;</div>
          <div style="text-indent: 2em">if operator == "+":</div>
          <div style="text-indent: 4em">return add</div>
          <div style="text-indent: 2em">elif operator == "-":</div>
          <div style="text-indent: 4em">return subtract</div>
          <div style="text-indent: 2em">elif operator == "*":</div>
          <div style="text-indent: 4em">return multiply</div>
          <div style="text-indent: 2em">elif operator == "/":</div>
          <div style="text-indent: 4em">return divide</div>

          <div>addition = calculate("+")</div>
          <div>print(addition(5, 3))</div>
          <div>&nbsp;</div>
          <div>subtraction = calculate("-")</div>
          <div>print(subtraction(5, 3))</div>
        </div>
        <div style="text-align: center; padding-top: 5px">
          <el-button icon="el-icon-caret-right" type="success" size="mini" @click="startStep21">运行结果
          </el-button>
          <el-button icon="el-icon-caret-right" type="success" size="mini" @click="startStep22">运行结果
          </el-button>
        </div>
      </div>
      <p>在上面的例子中，calculate()函数返回了一个嵌套的函数，这个嵌套的函数可以执行不同的操作（加法、减法、乘法、除法），具体由传入的参数决定。</p><p> </p><p>3. 高阶函数的常见应用场景</p><p>高阶函数在Python中有许多常见的应用场景，包括但不限于以下几种：</p><p> </p><p>① 函数式编程</p><p>函数式编程是一种编程范式，其中函数被视为一等公民，可以被传递和返回。高阶函数在函数式编程中被广泛使用，它可以让我们编写更加简洁、高效的代码。</p><p>例如，我们可以使用内置函数filter()来筛选出符合某一条件的元素：</p>
      <div style="background-color: #2B2B2B; color: white; width: 50%; border-radius: 15px; padding: 10px; margin-top: 5px">
        <div style="border: 1px solid #585858; padding: 5px">
          <pre><code class="language-python">def is_even(x):
    return x % 2 == 0

numbers = [1, 2, 3, 4, 5]
evens = filter(is_even, numbers)
print(list(evens))</code></pre><p><br></p>
        </div>
        <div style="text-align: center; padding-top: 5px">
          <el-button icon="el-icon-caret-right" type="success" size="mini" @click="startStep23">运行结果
          </el-button>
        </div>
      </div>
      <p>在上面的例子中，is_even()函数作为参数传递给filter()函数，用于筛选出numbers列表中的偶数。</p><p> </p><p>② 装饰器</p><p>装饰器是一种用于修改函数行为的技术，它可以在不修改原函数代码的情况下，为函数添加额外的功能。高阶函数可以用于实现装饰器。</p><p>例如，我们可以定义一个装饰器函数timer，用于计算函数的执行时间：</p><p><br></p>
      <div style="background-color: #2B2B2B; color: white; width: 50%; border-radius: 15px; padding: 10px; margin-top: 5px">
        <div style="border: 1px solid #585858; padding: 5px">
          <pre><code >import time

def timer(func):
    def wrapper(*args, **kwargs):
        start_time = time.time()
        result = func(*args, **kwargs)
        end_time = time.time()
        print("函数 {} 的执行时间为 {} 秒".format(func.__name__, end_time - start_time))
        return result
    return wrapper

@timer
def slow_function():
    time.sleep(2)

slow_function()</code></pre><p><br></p>
        </div>
        <div style="text-align: center; padding-top: 5px">
          <el-button icon="el-icon-caret-right" type="success" size="mini" @click="startStep24">运行结果
          </el-button>
        </div>
      </div>
      <p>在上面的例子中，timer函数是一个高阶函数，它接受一个函数作为参数，并返回一个新的函数wrapper，这个新的函数在执行时会计算函数的执行时间并输出。</p><p>装饰器可以通过在函数定义前加上@decorator_name的语法糖来使用，如上面的例子中的@timer。这样，当调用slow_function()时，实际上是调用了经过装饰器timer修饰后的wrapper函数，从而实现了计算函数执行时间的功能。</p><p> </p><p>③回调函数</p><p>回调函数是一种将函数作为参数传递给其他函数，并在特定事件发生时由其他函数调用的技术。高阶函数可以用于实现回调函数。</p><p>例如，我们可以定义一个函数process_data()，它接受一个数据列表和一个处理函数作为参数，然后将列表中的每个元素传递给处理函数进行处理：</p><p><br></p>
      <div style="background-color: #2B2B2B; color: white; width: 50%; border-radius: 15px; padding: 10px; margin-top: 5px">
        <div style="border: 1px solid #585858; padding: 5px">
          <pre><code class="language-python">def process_data(data, func):
    result = []
    for item in data:
        processed_item = func(item)
        result.append(processed_item)
    return result

def square(x):
    return x * x

def cube(x):
    return x * x * x

data = [1, 2, 3, 4, 5]
squared_data = process_data(data, square)
print(squared_data)  # 输出：[1, 4, 9, 16, 25]

cubed_data = process_data(data, cube)
print(cubed_data)  # 输出：[1, 8, 27, 64, 125]</code></pre><p><br></p>

        </div>
        <div style="text-align: center; padding-top: 5px">
          <el-button icon="el-icon-caret-right" type="success" size="mini" @click="startStep25">运行结果一
          </el-button>
          <el-button icon="el-icon-caret-right" type="success" size="mini" @click="startStep26">运行结果二
          </el-button>
        </div>
      </div>
      <p>在上面的例子中，process_data()函数接受一个数据列表和一个处理函数func作为参数，然后将列表中的每个元素传递给func进行处理，并将处理结果存入一个新的列表中。</p><p> </p><p> </p><p>小结</p><p>高阶函数是一种强大的编程技术，它可以让我们编写更加灵活和高效的代码。在Python中，高阶函数可以接受一个或多个函数作为参数，并且可以返回一个函数作为结果。它们可以用于实现装饰器、回调函数、以及使用匿名函数等各种编程场景。</p><p>在学习和使用高阶函数时，需要注意以下几点：</p><p>①函数是一等对象：在Python中，函数被视为一等对象，可以像其他对象一样进行传递、赋值、作为参数和返回值使用。理解函数是一等对象的概念对于理解高阶函数是至关重要的。</p><p>②熟悉内置函数和函数式编程模块：Python提供了丰富的内置函数和函数式编程模块，如map()、filter()、reduce()、functools等，它们可以帮助我们更方便地使用高阶函数。</p><p>③理解闭包和作用域：高阶函数常常与闭包和作用域相关联。理解闭包和作用域的概念对于理解高阶函数的工作原理和正确使用高阶函数非常重要。</p><p>④小心函数副作用：高阶函数中，传递的函数参数可能会对外部环境产生副作用，导致意外的结果。在使用高阶函数时，需要注意函数参数的副作用。</p><p>⑤代码可读性和维护性：使用高阶函数时，需要注意代码的可读性和维护性。过于复杂的嵌套函数和复杂的逻辑可能会导致代码难以理解和维护。</p><p>高阶函数是一种强大的编程技术，可以让你写出更加灵活和高效的代码。在实际的编程过程中，不断探索和运用高阶函数，将会带来更多的编程乐趣和效率。</p><p><br></p>
      <p style="font-weight: bold" id="eight">八、总结</p>
      <p>函数是 Python 编程的基础之一，掌握 Python 函数的各种特性和用法对我们的编程技能提升非常重要。通过本次实验，我们对 Python 函数的基本概念和用法进行了回顾，并学习了 Python 中一些更高级的函数特性和用法，包括默认参数、可变参数、lambda 表达式、高阶函数等等。</p>

    </div>
  </div>


</template>

<script>
  import {
    qryPaperList,
    uploadImgUrl,
    uploadPdfUrl,
    qryPaperTypeList,
    updatePaperInfo,
    delPaperInfo,
    authToken
  } from '../../request/api';
  import LeaderLine from 'leader-line-vue';

  export default {
    data() {
      return {
        step: 0,
        zhichuandi: true,
        zcdCode: [
          {id: 1, ml: 0, con: "#!/usr/bin/python", a: "?", b: "?", fk: false, nk: false},
          {id: 2, ml: 0, con: "# -*- coding: UTF-8 -*-", a: "?", b: "?", fk: false, nk: false},
          {id: 3, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
          {id: 4, ml: 0, con: "x = 3", a: "?", b: "?", fk: false, nk: false},
          {id: 5, ml: 0, con: "y = x", a: "?", b: "?", fk: false, nk: false},
          {id: 6, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
          {id: 7, ml: 0, con: "print(id(x))", a: "?", b: "?", fk: false, nk: false},
          {id: 8, ml: 0, con: "print(id(y))", a: "?", b: "?", fk: false, nk: false},
          {id: 9, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
        ],
        step1: 0,
        zcdCode1: [
          {id: 1, ml: 0, con: "#!/usr/bin/python", a: "?", b: "?", fk: false, nk: false},
          {id: 2, ml: 0, con: "# -*- coding: UTF-8 -*-", a: "?", b: "?", fk: false, nk: false},
          {id: 3, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
          {id: 4, ml: 0, con: "x = 3", a: "?", b: "?", fk: false, nk: false},
          {id: 5, ml: 0, con: "print(id(x))", a: "?", b: "?", fk: false, nk: false},
          {id: 6, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
          {id: 7, ml: 0, con: "x = 4", a: "?", b: "?", fk: false, nk: false},
          {id: 8, ml: 0, con: "print(id(x))", a: "?", b: "?", fk: false, nk: false},
          {id: 9, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
        ],
        step2: 0,
        zcdCode2: [
          {id: 1, ml: 0, con: "#!/usr/bin/python", a: "?", b: "?", fk: false, nk: false},
          {id: 2, ml: 0, con: "# -*- coding: UTF-8 -*-", a: "?", b: "?", fk: false, nk: false},
          {id: 3, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
          {id: 4, ml: 0, con: "x = [1,2,3]", a: "?", b: "?", fk: false, nk: false},
          {id: 5, ml: 0, con: "print(id(x))", a: "?", b: "?", fk: false, nk: false},
          {id: 6, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
          {id: 7, ml: 0, con: "x.append(4)", a: "?", b: "?", fk: false, nk: false},
          {id: 8, ml: 0, con: "print(id(x))", a: "?", b: "?", fk: false, nk: false},
          {id: 9, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
        ],
        step3: 0,
        zcdCode3: [
          {id: 1, ml: 0, con: "#!/usr/bin/python", a: "?", b: "?", fk: false, nk: false},
          {id: 2, ml: 0, con: "# -*- coding: UTF-8 -*-", a: "?", b: "?", fk: false, nk: false},
          {id: 3, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
          {id: 4, ml: 0, con: "def change(n):", a: "?", b: "?", fk: false, nk: false},
          {id: 5, ml: 2, con: "print(id(n))", a: "?", b: "?", fk: false, nk: false},
          {id: 6, ml: 2, con: "n = 1000", a: "?", b: "?", fk: false, nk: false},
          {id: 7, ml: 2, con: "print(id(n))", a: "?", b: "?", fk: false, nk: false},
          {id: 8, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
          {id: 9, ml: 0, con: "x = 3", a: "?", b: "?", fk: false, nk: false},
          {id: 10, ml: 0, con: "print(id(x))", a: "?", b: "?", fk: false, nk: false},
          {id: 11, ml: 0, con: "change(x)", a: "?", b: "?", fk: false, nk: false},
          {id: 12, ml: 0, con: "print(x)", a: "?", b: "?", fk: false, nk: false},
          {id: 13, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
        ],
        step4: 0,
        zcdCode4: [
          {id: 1, ml: 0, con: "#!/usr/bin/python", a: "?", b: "?", fk: false, nk: false},
          {id: 2, ml: 0, con: "# -*- coding: UTF-8 -*-", a: "?", b: "?", fk: false, nk: false},
          {id: 3, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
          {id: 4, ml: 0, con: "def change(n):", a: "?", b: "?", fk: false, nk: false},
          {id: 5, ml: 2, con: "print(id(n))", a: "?", b: "?", fk: false, nk: false},
          {id: 6, ml: 2, con: "n.append(4)", a: "?", b: "?", fk: false, nk: false},
          {id: 7, ml: 2, con: "print(id(n))", a: "?", b: "?", fk: false, nk: false},
          {id: 8, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
          {id: 9, ml: 0, con: "x = [1,2,3]", a: "?", b: "?", fk: false, nk: false},
          {id: 10, ml: 0, con: "print(id(x))", a: "?", b: "?", fk: false, nk: false},
          {id: 11, ml: 0, con: "change(x)", a: "?", b: "?", fk: false, nk: false},
          {id: 12, ml: 0, con: "print(x)", a: "?", b: "?", fk: false, nk: false},
          {id: 13, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
        ],
        step5: 0,
        zcdCode5: [
          {id: 1, ml: 0, con: "#!/usr/bin/python", a: "?", b: "?", fk: false, nk: false},
          {id: 2, ml: 0, con: "# -*- coding: UTF-8 -*-", a: "?", b: "?", fk: false, nk: false},
          {id: 3, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
          {id: 4, ml: 0, con: "def change(n):", a: "?", b: "?", fk: false, nk: false},
          {id: 5, ml: 2, con: "n.append(4)", a: "?", b: "?", fk: false, nk: false},
          {id: 6, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
          {id: 7, ml: 0, con: "x = [1,2,3]", a: "?", b: "?", fk: false, nk: false},
          {id: 8, ml: 0, con: "print(id(x))", a: "?", b: "?", fk: false, nk: false},
          {id: 9, ml: 0, con: "change(x[:])", a: "?", b: "?", fk: false, nk: false},
          {id: 10, ml: 0, con: "print(x)", a: "?", b: "?", fk: false, nk: false},
          {id: 11, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
        ],
        step6: 0,
        zcdCode6: [
          {id: 1, ml: 0, con: "#!/usr/bin/python", a: "?", b: "?", fk: false, nk: false},
          {id: 2, ml: 0, con: "# -*- coding: UTF-8 -*-", a: "?", b: "?", fk: false, nk: false},
          {id: 3, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
          {id: 4, ml: 0, con: "lambda x, y: x*y:", a: "# 函数输入是x和y，输出是它们的积x*y", b: "?", fk: false, nk: false},
          {id: 5, ml: 0, con: "lambda:None", a: "# 函数没有输入参数，输出是None", b: "?", fk: false, nk: false},
          {id: 6, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
          {id: 7, ml: 0, con: "lambda *args: sum(args)", a: "# 输入是任意个数参数，输出是它们的和(隐性要求输入参数必须能进行算术运算)", b: "?", fk: false, nk: false},
          {id: 8, ml: 0, con: "lambda **kwargs: 1", a: "# 输入是任意键值对参数，输出是1", b: "?", fk: false, nk: false},
        ],
        zcdCode7: [
          {id: 1, ml: 0, con: "#!/usr/bin/python", a: "?", b: "?", fk: false, nk: false},
          {id: 2, ml: 0, con: "# -*- coding: UTF-8 -*-", a: "?", b: "?", fk: false, nk: false},
          {id: 3, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
          {id: 4, ml: 0, con: "add = lambda x, y: x+y", a: "# 函数输入是x和y，输出是它们的积x*y", b: "?", fk: false, nk: false},
          {id: 5, ml: 0, con: "lambda:None", a: "# 函数没有输入参数，输出是None", b: "?", fk: false, nk: false},
          {id: 6, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
          {id: 7, ml: 0, con: "lambda *args: sum(args)", a: "# 输入是任意个数参数，输出是它们的和(隐性要求输入参数必须能进行算术运算)", b: "?", fk: false, nk: false},
          {id: 8, ml: 0, con: "lambda **kwargs: 1", a: "# 输入是任意键值对参数，输出是1", b: "?", fk: false, nk: false},
        ],
        zcd: {
          main: {
            a: '?',
            b: '?',
          },
          swap: {
            a: '?',
            b: '?',
            t: '?',
          },
          swapShow: false,
        },
        answerVisible: false,
        answerInfoVisible: false,
        answerInfoSuccessVisible: false,
        zcdAnswer: {
          a: '',
          b: ''
        },
        showStep: true,
        nowScore: 0,
        close: false,
        xLeaderLine: null,
        yLeaderLine: null,
        xLeaderLine1: null,
        xLeaderLine2: null,
        xLeaderLine3: null,
        xLeaderLine4: null,
        xLeaderLine5: null,
        xLeaderLine6: null,
        xLeaderLine7: null,
        xLeaderLine8: null,
        xLeaderLine9: null,
        xLeaderLine10: null,
        xLeaderLine11: null,

      };
    },
    methods: {
      handleScroll() {
        if (this.xLeaderLine != null) {
          this.xLeaderLine.position();
        }
        if (this.yLeaderLine != null) {
          this.yLeaderLine.position();
        }
        if (this.xLeaderLine1 != null) {
          this.xLeaderLine1.position();
        }
        if (this.xLeaderLine2 != null) {
          this.xLeaderLine2.position();
        }
        if (this.xLeaderLine3 != null) {
          this.xLeaderLine3.position();
        }
        if (this.xLeaderLine4 != null) {
          this.xLeaderLine4.position();
        }
        if (this.xLeaderLine5 != null) {
          this.xLeaderLine5.position();
        }
        if (this.xLeaderLine6 != null) {
          this.xLeaderLine6.position();
        }
        if (this.xLeaderLine7 != null) {
          this.xLeaderLine7.position();
        }
        if (this.xLeaderLine8 != null) {
          this.xLeaderLine8.position();
        }
        if (this.xLeaderLine9 != null) {
          this.xLeaderLine9.position();
        }
        if (this.xLeaderLine10 != null) {
          this.xLeaderLine10.position();
        }
        if (this.xLeaderLine11 != null) {
          this.xLeaderLine11.position();
        }

      },
      startStep1() {
        this.step1 = 0;
        this.zcdStepCon1();
        if (this.xLeaderLine1 != null) {
          this.xLeaderLine1.remove();
          this.xLeaderLine1 = null
        }
        this.xLeaderLine2.remove();
        if (this.xLeaderLine2 != null) {
          this.xLeaderLine2.remove();
          this.xLeaderLine2 = null
        }
      },
      startStep2() {
        this.step2 = 0;
        this.zcdStepCon2();
        if (this.xLeaderLine3 != null) {
          this.xLeaderLine3.remove();
          this.xLeaderLine3 = null
        }

      },
      startStep3() {
        this.step3 = 0;
        this.zcdStepCon3();
        if (this.xLeaderLine4 != null) {
          this.xLeaderLine4.remove();
          this.xLeaderLine4 = null
        }
        if (this.xLeaderLine5 != null) {
          this.xLeaderLine5.remove();
          this.xLeaderLine5 = null
        }
        if (this.xLeaderLine6 != null) {
          this.xLeaderLine6.remove();
          this.xLeaderLine6 = null
        }

      },
      startStep4() {
        this.step4= 0;
        this.zcdStepCon4();
        if (this.xLeaderLine7 != null) {
          this.xLeaderLine7.remove();
          this.xLeaderLine7 = null
        }
        if (this.xLeaderLine8 != null) {
          this.xLeaderLine8.remove();
          this.xLeaderLine8 = null
        }

      },
      startStep5() {
        this.step5 = 0;
        this.zcdStepCon5();
        if (this.xLeaderLine9 != null) {
          this.xLeaderLine9.remove();
          this.xLeaderLine9 = null
        }
        if (this.xLeaderLine10 != null) {
          this.xLeaderLine10.remove();
          this.xLeaderLine10 = null
        }

      },
      startStep61() {
        this.step6 = 0
        this.zcdStepCon6();
      },
      startStep6() {
        this.$prompt('猜一下预期结果吧', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          if (value == '[1, 4, 9, 16, 25]') {
            this.$message({
              type: 'success',
              message: '恭喜你，答对了'
            });
          } else {
            this.$message({
              type: 'error',
              message: '答错了，正确答案为：[1, 4, 9, 16, 25]'
            });
          }

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      },
      startStep7() {
        this.$prompt('猜一下预期结果吧', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          if (value == '[1, 4, 9, 16, 25]') {
            this.$message({
              type: 'success',
              message: '恭喜你，答对了'
            });
          } else {
            this.$message({
              type: 'error',
              message: '答错了，正确答案为：[1, 4, 9, 16, 25]'
            });
          }

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      },
      startStep8() {
        this.$prompt('猜一下预期结果吧', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          if (value == '[3, 7, 11, 15, 19]') {
            this.$message({
              type: 'success',
              message: '恭喜你，答对了'
            });
          } else {
            this.$message({
              type: 'error',
              message: '答错了，正确答案为：[3, 7, 11, 15, 19]'
            });
          }

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      },
      startStep9() {
        this.$prompt('猜一下预期结果吧', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          if (value == '5') {
            this.$message({
              type: 'success',
              message: '恭喜你，答对了'
            });
          } else {
            this.$message({
              type: 'error',
              message: '答错了，正确答案为：5'
            });
          }

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      },
      startStep10() {
        this.$prompt('猜一下预期结果吧', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          if (value == '13579') {
            this.$message({
              type: 'success',
              message: '恭喜你，答对了'
            });
          } else {
            this.$message({
              type: 'error',
              message: '答错了，正确答案为：13579'
            });
          }

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      },
      startStep11() {
        this.$prompt('猜一下预期结果吧', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          if (value == '[5, 7, 6, 3, 4, 1, 2]') {
            this.$message({
              type: 'success',
              message: '恭喜你，答对了'
            });
          } else {
            this.$message({
              type: 'error',
              message: '答错了，正确答案为：[5, 7, 6, 3, 4, 1, 2]'
            });
          }

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      },
      startStep12() {
        this.$prompt('猜一下预期结果吧', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          if (value == '[1, 2, 3, 4, 5, 6, 7]') {
            this.$message({
              type: 'success',
              message: '恭喜你，答对了'
            });
          } else {
            this.$message({
              type: 'error',
              message: '答错了，正确答案为：[1, 2, 3, 4, 5, 6, 7]'
            });
          }

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      },
      startStep13() {
        this.$prompt('猜一下预期结果吧', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          if (value == '[(\'a\', 1), (\'b\', 2), (\'c\', 3), (\'d\', 4)]') {
            this.$message({
              type: 'success',
              message: '恭喜你，答对了'
            });
          } else {
            this.$message({
              type: 'error',
              message: '答错了，正确答案为：[(\'a\', 1), (\'b\', 2), (\'c\', 3), (\'d\', 4)]'
            });
          }

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      },
      startStep14() {
        this.$prompt('猜一下预期结果吧', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          if (value == '[(\'a\', 1), (\'b\', 2), (\'c\', 3), (\'d\', 4)]') {
            this.$message({
              type: 'success',
              message: '恭喜你，答对了'
            });
          } else {
            this.$message({
              type: 'error',
              message: '答错了，正确答案为：[(\'a\', 1), (\'b\', 2), (\'c\', 3), (\'d\', 4)]'
            });
          }

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      },
      startStep15() {
        this.$prompt('猜一下预期结果吧', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          if (value == '[(\'dave\', \'B\', 10), (\'jane\', \'B\', 12), (\'john\', \'A\', 15)]') {
            this.$message({
              type: 'success',
              message: '恭喜你，答对了'
            });
          } else {
            this.$message({
              type: 'error',
              message: '答错了，正确答案为：[(\'dave\', \'B\', 10), (\'jane\', \'B\', 12), (\'john\', \'A\', 15)]'
            });
          }

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      },
      startStep16() {
        this.$prompt('猜一下预期结果吧', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          if (value == '[(\'john\', \'A\', 15), (\'jane\', \'B\', 12), (\'dave\', \'B\', 10)]') {
            this.$message({
              type: 'success',
              message: '恭喜你，答对了'
            });
          } else {
            this.$message({
              type: 'error',
              message: '答错了，正确答案为：[(\'john\', \'A\', 15), (\'jane\', \'B\', 12), (\'dave\', \'B\', 10)]'
            });
          }

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      },
      startStep17() {
        this.$prompt('猜一下预期结果吧', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          if (value == '[1, 3, 5, 7, 9]') {
            this.$message({
              type: 'success',
              message: '恭喜你，答对了'
            });
          } else {
            this.$message({
              type: 'error',
              message: '答错了，正确答案为：[1, 3, 5, 7, 9]'
            });
          }

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      },
      startStep18() {
        this.$prompt('猜一下预期结果吧', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          if (value == '[3]') {
            this.$message({
              type: 'success',
              message: '恭喜你，答对了'
            });
          } else {
            this.$message({
              type: 'error',
              message: '答错了，正确答案为：[3]'
            });
          }

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      },
      startStep19() {
        this.$prompt('猜一下预期结果吧', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          if (value == '[1, 4, 9, 16, 25]') {
            this.$message({
              type: 'success',
              message: '恭喜你，答对了'
            });
          } else {
            this.$message({
              type: 'error',
              message: '答错了，正确答案为：[1, 4, 9, 16, 25]'
            });
          }

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      },
      startStep20() {
        this.$prompt('猜一下预期结果吧', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          if (value == '8') {
            this.$message({
              type: 'success',
              message: '恭喜你，答对了'
            });
          } else {
            this.$message({
              type: 'error',
              message: '答错了，正确答案为：8'
            });
          }

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      },
      startStep21() {
        this.$prompt('猜一下预期结果吧', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          if (value == '8') {
            this.$message({
              type: 'success',
              message: '恭喜你，答对了'
            });
          } else {
            this.$message({
              type: 'error',
              message: '答错了，正确答案为：8'
            });
          }

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      },
      startStep22() {
        this.$prompt('猜一下预期结果吧', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          if (value == '2') {
            this.$message({
              type: 'success',
              message: '恭喜你，答对了'
            });
          } else {
            this.$message({
              type: 'error',
              message: '答错了，正确答案为：2'
            });
          }

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      },
      startStep23() {
        this.$prompt('猜一下预期结果吧', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          if (value == '[2, 4]') {
            this.$message({
              type: 'success',
              message: '恭喜你，答对了'
            });
          } else {
            this.$message({
              type: 'error',
              message: '答错了，正确答案为：[2, 4]'
            });
          }

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      },
      startStep24() {
        this.$message({
          type: 'info',
          message: '2.0001258850097656 秒'
        });
      },
      startStep25() {
        this.$prompt('猜一下预期结果吧', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          if (value == '[1, 4, 9, 16, 25]') {
            this.$message({
              type: 'success',
              message: '恭喜你，答对了'
            });
          } else {
            this.$message({
              type: 'error',
              message: '答错了，正确答案为：[1, 4, 9, 16, 25]'
            });
          }

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      },
      startStep26() {
        this.$prompt('猜一下预期结果吧', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          if (value == '[1, 8, 27, 64, 125]') {
            this.$message({
              type: 'success',
              message: '恭喜你，答对了'
            });
          } else {
            this.$message({
              type: 'error',
              message: '答错了，正确答案为：[1, 8, 27, 64, 125]'
            });
          }

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      },
      startStep() {
        this.step = 0;
        this.zcdStepCon();
        if (this.xLeaderLine != null) {
          this.xLeaderLine.remove();
          this.xLeaderLine = null
        }
        if (this.yLeaderLine != null) {
          this.yLeaderLine.remove();
          this.yLeaderLine = null
        }
      },
      nextStep() {
        if (this.zhichuandi) {
          // 步骤增加1
          this.step++;
          this.zcdStepCon();
        }
      },
      nextStep1() {
        if (this.zhichuandi) {
          // 步骤增加1
          this.step1++;
          this.zcdStepCon1();
        }
      },
      nextStep2() {
        if (this.zhichuandi) {
          // 步骤增加1
          this.step2++;
          this.zcdStepCon2();
        }
      },
      nextStep3() {
        if (this.zhichuandi) {
          // 步骤增加1
          this.step3++;
          this.zcdStepCon3();
        }
      },
      nextStep4() {
        if (this.zhichuandi) {
          // 步骤增加1
          this.step4++;
          this.zcdStepCon4();
        }
      },
      nextStep5() {
        if (this.zhichuandi) {
          // 步骤增加1
          this.step5++;
          this.zcdStepCon5();
        }
      },
      nextStep6() {
        if (this.zhichuandi) {
          // 步骤增加1
          this.step6++;
          this.zcdStepCon6();
        }
      },


      zcdStepCon1() {
        // 第二步
        this.zcdCode1.forEach(item => {
          item.fk = false;
          item.nk = false;
        });
        if (this.step1 === 1) {

          this.zcdCode1[3].fk = true;

          this.$nextTick(() => {
            // 在DOM元素上初始化LeaderLine
            const targetAim = document.querySelector('#targetAim1');
            const target2 = document.querySelector('#target6');
            this.xLeaderLine1 = LeaderLine.setLine(target2, targetAim);
          });

        } else if (this.step1 === 2) {
          // 第二步
          this.zcdCode1.forEach(item => {
            item.fk = false;
            item.nk = false;
          });
          this.zcdCode1[4].fk = true;

        } else if (this.step1 === 3) {
          // 第三步
          this.zcdCode1.forEach(item => {
            item.fk = false;
            item.nk = false;
          });
          this.zcdCode1[6].fk = true;
          this.$nextTick(() => {
            this.xLeaderLine1.hide()
          });
          this.$nextTick(() => {
            // 在DOM元素上初始化LeaderLine
            const targetAim = document.querySelector('#targetAim11');
            const target1 = document.querySelector('#target6');
            this.xLeaderLine2 = LeaderLine.setLine(target1, targetAim);

          });

        } else if (this.step1 === 4) {
          // 第四步
          this.zcdCode1.forEach(item => {
            item.fk = false;
            item.nk = false;
          });
          this.zcdCode1[7].fk = true;

        }

      },
      zcdStepCon2() {
        // 第二步
        this.zcdCode2.forEach(item => {
          item.fk = false;
          item.nk = false;
        });
        if (this.step2 === 1) {

          this.zcdCode2[3].fk = true;

          this.$nextTick(() => {
            // 在DOM元素上初始化LeaderLine
            const targetAim = document.querySelector('#targetAim2');
            const target2 = document.querySelector('#target12');
            this.xLeaderLine3 = LeaderLine.setLine(target2, targetAim);
          });
        } else if (this.step2 === 2) {
          this.zcdCode2[4].fk = true;

        } else if (this.step2 === 3) {
          this.$nextTick(() => {
            this.xLeaderLine3.position()
          })


          this.zcdCode2[6].fk = true;

        } else if (this.step2 === 4) {
          this.zcdCode2[7].fk = true;
        }

      },
      zcdStepCon3() {

        // 第二步
        this.zcdCode3.forEach(item => {
          item.fk = false;
          item.nk = false;
        });
        if (this.step3 === 1) {

          this.zcdCode3[8].fk = true;

          this.$nextTick(() => {
            // 在DOM元素上初始化LeaderLine
            const targetAim = document.querySelector('#targetAim32');
            const target2 = document.querySelector('#target312');
            this.xLeaderLine4 = LeaderLine.setLine(target2, targetAim);
          });

        } else if (this.step3 === 2) {
          this.zcdCode3[9].fk = true;
        } else if (this.step3 === 3) {
          // 在DOM元素上初始化LeaderLine
          this.$nextTick(() => {
            const targetAim = document.querySelector('#targetAim32');
            const target2 = document.querySelector('#target311');
            this.xLeaderLine5 = LeaderLine.setLine(target2, targetAim);
            this.zcdCode3[4].fk = true;
          })


        } else if (this.step3 === 4) {
          this.$nextTick(() => {
          // 在DOM元素上初始化LeaderLine
            const targetAim = document.querySelector('#targetAim33');
            const target2 = document.querySelector('#target311');
            this.xLeaderLine5.hide()
            this.xLeaderLine6 = LeaderLine.setLine(target2, targetAim);
            this.zcdCode3[5].fk = true;
          });


        } else if (this.step3 === 5) {

          this.zcdCode3[6].fk = true;

        }else if (this.step3 === 6) {

          this.zcdCode3[11].fk = true;

        }
      },
      zcdStepCon4() {
        // 第二步
        this.zcdCode4.forEach(item => {
          item.fk = false;
          item.nk = false;
        });
        if (this.step4 === 1) {

          this.zcdCode4[8].fk = true;

          this.$nextTick(() => {
            // 在DOM元素上初始化LeaderLine
            const targetAim = document.querySelector('#targetAim42');
            const target2 = document.querySelector('#target412');
            this.xLeaderLine7 = LeaderLine.setLine(target2, targetAim);
          });

        } else if (this.step4 === 2) {

          this.zcdCode4[9].fk = true;
        } else if (this.step4 === 3) {
          this.$nextTick(() => {
            const targetAim = document.querySelector('#targetAim42');
            const target2 = document.querySelector('#target411');
            this.xLeaderLine8 = LeaderLine.setLine(target2, targetAim);
            this.zcdCode3[4].fk = true;
          })
          this.zcdCode4[4].fk = true;

        } else if (this.step4 === 4) {
          this.$nextTick(() => {
            this.xLeaderLine7.position()
            this.xLeaderLine8.position()
          })
          this.zcdCode4[5].fk = true;

        } else if (this.step4 === 5) {

          this.zcdCode4[6].fk = true;

        }else if (this.step4 === 6) {

          this.zcdCode4[11].fk = true;

        }
      },
      zcdStepCon5() {
        // 第二步
        this.zcdCode5.forEach(item => {
          item.fk = false;
          item.nk = false;
        });
        if (this.step5 === 1) {

          this.zcdCode5[6].fk = true;

          this.$nextTick(() => {
            // 在DOM元素上初始化LeaderLine
            const targetAim = document.querySelector('#targetAim52');
            const target2 = document.querySelector('#target512');
            this.xLeaderLine9 = LeaderLine.setLine(target2, targetAim);
          });

        } else if (this.step5 === 2) {
          this.zcdCode5[7].fk = true;
        } else if (this.step5 === 3) {
          this.$nextTick(() => {
            // 在DOM元素上初始化LeaderLine
            const targetAim = document.querySelector('#targetAim53');
            const target2 = document.querySelector('#target511');
            this.xLeaderLine10 = LeaderLine.setLine(target2, targetAim);
          });
          this.zcdCode5[3].fk = true;
        } else if (this.step5 === 4) {
          this.$nextTick(() => {
            this.xLeaderLine10.position()
          });
          this.zcdCode5[4].fk = true;
        } else if (this.step5 === 5) {
          this.zcdCode5[9].fk = true;
        }
      },
      zcdStepCon6() {
        // 第二步
        this.zcdCode6.forEach(item => {
          item.fk = false;
          item.nk = false;
        });
        if (this.step6 === 1) {
          this.zcdCode6[3].fk = true;
        } else if (this.step6 === 2) {
          this.zcdCode6[4].fk = true;
        } else if (this.step6 === 3) {
          this.zcdCode6[6].fk = true;
        } else if (this.step6 === 4) {
          this.zcdCode6[7].fk = true;
        }

      },
      zcdStepCon() {
        // 第二步
        this.zcdCode.forEach(item => {
          item.fk = false;
          item.nk = false;
        });
        if (this.step === 1) {

          this.zcdCode[3].fk = true;

          this.zcd.main.a = "?";
          this.zcd.main.b = "?";
          this.zcd.swapShow = false

          this.$nextTick(() => {
            // 在DOM元素上初始化LeaderLine
            const targetAim = document.querySelector('#targetAim');
            const target2 = document.querySelector('#target2');
            this.xLeaderLine = LeaderLine.setLine(target2, targetAim);
          });

        } else if (this.step === 2) {
          // 第二步
          this.zcdCode.forEach(item => {
            item.fk = false;
            item.nk = false;
          });
          this.zcdCode[4].fk = true;

          this.$nextTick(() => {
            // 在DOM元素上初始化LeaderLine
            const targetAim = document.querySelector('#targetAim');
            const target1 = document.querySelector('#target1');
            this.yLeaderLine = LeaderLine.setLine(target1, targetAim);
          });

        } else if (this.step === 3) {
          // 第三步
          this.zcdCode.forEach(item => {
            item.fk = false;
            item.nk = false;
          });
          this.zcdCode[6].fk = true;

        } else if (this.step === 4) {
          // 第四步
          this.zcdCode.forEach(item => {
            item.fk = false;
            item.nk = false;
          });
          this.zcdCode[7].fk = true;

        }

      }
    },
    beforeDestroy() {
      if (this.xLeaderLine != null) {
        this.xLeaderLine.remove();
        this.xLeaderLine = null
      }
      if (this.yLeaderLine != null) {
        this.yLeaderLine.remove();
        this.yLeaderLine = null
      }
      if (this.xLeaderLine1 != null) {
        this.xLeaderLine1.remove();
        this.xLeaderLine1 = null
      }
      if (this.xLeaderLine2 != null) {
        this.xLeaderLine2.remove();
        this.xLeaderLine2 = null
      }
      if (this.xLeaderLine3 != null) {
        this.xLeaderLine3.remove();
        this.xLeaderLine3 = null
      }
      if (this.xLeaderLine4 != null) {
        this.xLeaderLine4.remove();
        this.xLeaderLine4 = null
      }
      if (this.xLeaderLine5 != null) {
        this.xLeaderLine5.remove();
        this.xLeaderLine5 = null
      }
      if (this.xLeaderLine6 != null) {
        this.xLeaderLine6.remove();
        this.xLeaderLine6 = null
      }
      if (this.xLeaderLine7 != null) {
        this.xLeaderLine7.remove();
        this.xLeaderLine7 = null
      }
      if (this.xLeaderLine8 != null) {
        this.xLeaderLine8.remove();
        this.xLeaderLine8 = null
      }
      if (this.xLeaderLine9 != null) {
        this.xLeaderLine9.remove();
        this.xLeaderLine9 = null
      }
      if (this.xLeaderLine10 != null) {
        this.xLeaderLine10.remove();
        this.xLeaderLine10 = null
      }
      if (this.xLeaderLine11 != null) {
        this.xLeaderLine11.remove();
        this.xLeaderLine11 = null
      }

    },
    destroyed() {

    },
    mounted() {

    },
    props: ["itemData"]
  };
</script>

<style lang="less">

  .menu {
    position: fixed; /* 将菜单固定在页面顶端 */
    top: 142px;
    left: 40px;
    right: 40px;
    width: calc(100% - 120px); /* 菜单宽度占满整个页面 */
    background-color: #f1f1f1; /* 菜单背景色 */
    z-index: 999; /* 将菜单置于最上层 */
  }

  .menu ul {
    list-style: none; /* 去除列表前的点 */
    padding: 0; /* 去除列表间距 */
    margin: 0;
  }

  .menu ul li {
    float: left; /* 将列表项水平排列 */
  }

  .menu ul li a {
    display: block; /* 将链接以块级元素显示 */
    padding: 10px; /* 链接内边距 */
    color: #333; /* 链接文本颜色 */
    text-decoration: none; /* 去除链接下划线 */
  }

  .menu ul li a:hover {
    background-color: #ddd; /* 鼠标悬停时更改链接背景色 */
  }

  .lwgl {
    background-color: #EFF3FF;
    padding: 20px;
    height: calc(100vh - 216px);
    overflow-y: auto;
    line-height: 27px;
    font-size: 16px;
  }

  .el-table th.el-table__cell {
    background-color: #EFF3FF;
  }

  .searchClass {
    width: 900px;
    height: 70px;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .avatar-uploader {
    text-align: left;
  }

  .upload-demo {
    text-align: left;
  }

  .lwgl .el-table .el-table__body-wrapper {
    height: calc(100vh - 455px);
    min-height: 250px;
    overflow-y: auto;
  }

  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
  }

  .el-select {
    width: 100%;
  }

  .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
    padding-left: 10px;
    padding-right: 10px;
  }

  .searchClass .el-form--inline .el-form-item__content {
    margin-top: 13px;
  }

</style>




// WEBPACK FOOTER //
// src/components/lw/lwgl01.vue